import { render, staticRenderFns } from "./siteNav.vue?vue&type=template&id=3c1d07c4&"
import script from "./siteNav.vue?vue&type=script&lang=js&"
export * from "./siteNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports